// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__23QZL","file":"styles_file__7rFCN"};